import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Recycle, Package, ShoppingBag, Calculator, Settings, Users, LogOut, MessageCircle } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/tradeins", label: "Trade-Ins", icon: Recycle },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/simulator", label: "Simulator", icon: Calculator },
  { to: "/admin/whatsapp", label: "WhatsApp", icon: MessageCircle },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout({ children, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-[hsl(var(--muted))]">
      <aside className="hidden md:flex flex-col w-60 bg-secondary text-secondary-foreground shrink-0 sticky top-0 h-screen">
        <div className="p-5 border-b border-white/10">
          <BrandMark dark iconSize={32} />
          <div className="text-[10px] uppercase tracking-widest text-secondary-foreground/60 mt-1.5 ml-[42px]">Admin Console</div>
        </div>
        <nav className="p-3 flex-1 space-y-1">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={`admin-nav-${it.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${isActive ? "bg-primary text-primary-foreground" : "text-secondary-foreground/80 hover:bg-white/10"}`}>
              <it.icon size={17} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <button onClick={() => navigate("/")} className="w-full text-left px-3 py-2 rounded-md text-sm hover:bg-white/10">← Storefront</button>
          <button onClick={() => { logout(); navigate("/"); }} className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm hover:bg-white/10"><LogOut size={15} /> Logout</button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <header className="bg-card border-b border-border px-4 sm:px-6 h-16 flex items-center justify-between sticky top-0 z-30">
          <h1 className="font-heading font-bold text-xl">{title}</h1>
          <div className="text-sm text-muted-foreground hidden sm:block">{user?.name} · <span className="uppercase text-xs">{user?.role}</span></div>
        </header>
        {/* mobile nav */}
        <div className="md:hidden flex gap-1 overflow-x-auto p-2 bg-card border-b border-border">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} className={({ isActive }) => `whitespace-nowrap px-3 py-1.5 rounded-md text-xs font-semibold ${isActive ? "bg-primary text-primary-foreground" : "bg-muted"}`}>{it.label}</NavLink>
          ))}
        </div>
        <div className="p-4 sm:p-6">{children}</div>
      </div>
    </div>
  );
}
